const accessDay = {
    DAY_LIST: { name: 'Day', path: '/day-list' },
    ADD_DAY: { name: 'Add Day', path: '/create-day' },
    UPDATE_DAY: { name: 'Update Day', path: '/edit-day' },
    DELETE_DAY: { name: 'Delete Day', path: '/delete-day' },
}

export default accessDay;
